import Dialog from 'components/common/material/Dialog';
import RaisedButton from 'components/common/material/RaisedButton';
import LoadingBlocking from 'components/loading/LoadingBlocking';
import PropTypes from 'prop-types';
import React from 'react';
import CSSModules from 'react-css-modules';
import { FormattedMessage, injectIntl, intlShape } from 'react-intl';
import { connect } from 'react-redux';
import * as thunkActionHelpers from 'utils/redux/thunkActionHelpers';
import contactUsUrl from 'utils/url/contactUsUrl';
import DebitCardForm from '../../components/common/debitCardForm/DebitCardForm';
import * as purchaseConstants from '../constants';
import { getPurchaseMergedStatus } from '../helpers';
import PurchaseInfo from '../PurchaseInfo';
import getCurrentPaymentMethodTextByPurchase from "utils/getCurrentPaymentMethodTextByPurchase";
import { purchasesUpdateDebitCardResetAction, purchaseUpdateDebitCardAction, PURCHASE_UPDATE_DEBIT_CARD } from '../redux';
import styles from './updateDebitCard.scss';
import { trackEvent } from "../../reducers/analyticsReducer";
import { datadogRum } from '@datadog/browser-rum';
import _get from "utils/get";

@injectIntl
@connect(
  (state) => {
    return {
      actionType: state.purchases.type,
      actionStatus: state.purchases.status,
      error: state.purchases.error,
      email: state.auth.user.email || ''
    };
  },
  dispatch => ({
    purchaseUpdateDebitCardAction: (externalId, debitCardDetails) => dispatch(purchaseUpdateDebitCardAction(externalId, debitCardDetails.cardNumber, debitCardDetails.expirationMonth, debitCardDetails.expirationYear, debitCardDetails.cvv)),
    purchasesUpdateDebitCardResetAction: () => dispatch(purchasesUpdateDebitCardResetAction()),
    trackEvent: (event, properties) => dispatch(trackEvent(event, properties)),
  })
)
@CSSModules(styles, {allowMultiple: true})
export default class UpdateDebitCard extends React.Component {

  static propTypes = {
    intl: intlShape, // react-inlt
    purchase: PropTypes.object.isRequired,
    purchaseUpdateDebitCardAction: PropTypes.func.isRequired,
    purchasesUpdateDebitCardResetAction: PropTypes.func.isRequired,
    doneCallback: PropTypes.func.isRequired,
    toggleDetails: PropTypes.func.isRequired,
    email: PropTypes.string.isRequired,
    actionType: PropTypes.string.isRequired,
    actionStatus: PropTypes.string.isRequired,
    trackEvent: PropTypes.func,
  };

  constructor(props) {
    super(props);
    this.state = {
      authorizationDialogVisible: false,
      hasLatePaymentsDialog: false,
      debitCardDetails: undefined,
      cvvKey: 'cvvKey'
    };
  }

  componentWillReceiveProps(nextProps) {
    const error = _get(nextProps, ['error', 'response', 'data']);
    const {customerId, externalId} = _get(nextProps, ['purchase'], {});

    if (thunkActionHelpers.actionFail(PURCHASE_UPDATE_DEBIT_CARD, nextProps.actionType, nextProps.actionStatus)) {
      this.resetCvv();
      datadogRum.addUserAction('Purchase update debit failed', {error, customerId, externalId})
    }

    if (thunkActionHelpers.actionSuccess(PURCHASE_UPDATE_DEBIT_CARD, nextProps.actionType, nextProps.actionStatus)) {
      datadogRum.addUserAction('Purchase update debit success', {customerId, externalId})
    }
  }

  onChange = (value, name) => {
    this.setState(() => ({[name]: value}));
  }

  toggleAuthorizarionDialog = () => {
    this.setState({authorizationDialogVisible: !this.state.authorizationDialogVisible});
    this.props.purchasesUpdateDebitCardResetAction();
  }

  toggleHasLatePaymentsDialog = () => {
    this.setState({hasLatePaymentsDialog: !this.state.hasLatePaymentsDialog});
  }

  updateDebitCardSuccessDone = () => {
    const {toggleDetails, purchase, doneCallback} = this.props;
    doneCallback();
    this.toggleAuthorizarionDialog();

    if (getPurchaseMergedStatus(purchase) === purchaseConstants.PURCHASE_STATUS_MERGED_LATE) {
      this.toggleHasLatePaymentsDialog();
    }
    else {
      toggleDetails();
    }
  }

  resetCvv = () => {
    this.setState(() => ({cvvKey: 'cvvKey_' + Date.now()}));
  };

  renderApplyToAllActiveCheckbox() {

    const allPurchases = <button><FormattedMessage id="updateDebitCard.applyToAllPurchases.linkTitle"/></button>;

    return (
      <div styleName="applyToAllActive">
        <FormattedMessage id="updateDebitCard.applyToAllPurchases.text" values={{allPurchases}}/>
      </div>
    );
  }

  renderApplyButton() {
    return (
      <RaisedButton data-at="continueBtn" primary={true} onClick={this.toggleAuthorizarionDialog} disabled={!this.state.debitCardDetails}><FormattedMessage id="common.continue"/></RaisedButton>
    );
  }

  renderAuthorizationDialog() {
    const {email, purchase: {externalId, customerId}, actionType, actionStatus, purchaseUpdateDebitCardAction, intl: {formatMessage}} = this.props;
    const debitCardDetails = this.state.debitCardDetails;

    let values = {
      externalId,
      cardLast4Digits: (debitCardDetails ? debitCardDetails.cardNumber + '' : '').slice(-4),
      customerId
    };


    let text = <FormattedMessage id="updateDebitCard.authorization.singlePurchase" data-at="confirmationTxt" values={values}/>;

    const confirmClick= () => {
      purchaseUpdateDebitCardAction(externalId, debitCardDetails);
    };

    let actions = [
      { label: formatMessage({id: 'common.cancel'}), onClick: this.toggleAuthorizarionDialog, name: "cancelUpdateDebit" },
      { label: formatMessage({id: 'common.confirm'}), onClick: confirmClick, primary: true, name: "confirmUpdateDebit" },
    ];

    if (thunkActionHelpers.actionSuccess(PURCHASE_UPDATE_DEBIT_CARD, actionType, actionStatus)) {
      let values = {email};
      text = <FormattedMessage id="updateDebitCard.authorization.singlePurchase.success" values={values}/>;
      actions = [
        { label: formatMessage({id: 'common.close'}), onClick: this.updateDebitCardSuccessDone , name: "updateDebitCardSuccessCloseBtn"},
      ];
    }

    if (thunkActionHelpers.actionFail(PURCHASE_UPDATE_DEBIT_CARD, actionType, actionStatus)) {
      let values = {
        contactUs: <a href={contactUsUrl()} target="_blank">{formatMessage({id:'common.link.contactUs.text'})}</a>
      };
      text = <FormattedMessage id="updateDebitCard.authorization.singlePurchase.fail" values={values}/>;
      actions = [
        { label: formatMessage({id: 'common.close'}), onClick: this.toggleAuthorizarionDialog , name: "updateDebitCardFailedCloseBtn"},
      ];
    }

    return (
      <Dialog active={true} actions={actions} title={formatMessage({id: 'updateDebitCard.authorization.title'})}>
        {thunkActionHelpers.actionPending(PURCHASE_UPDATE_DEBIT_CARD, actionType, actionStatus) && <LoadingBlocking />}
        <div styleName="dialogText" data-at="confirmationTxt" >{text}</div>
      </Dialog>
    );

  }

  renderHasLatePaymentsDialog() {
    const {toggleDetails, togglePayNow, intl: {formatMessage}} = this.props;
    let actions = [
      { label: formatMessage({id: 'common.no'}), onClick: toggleDetails, 'data-at': 'toggleDetails' },
      { label: formatMessage({id: 'common.yes'}), onClick: (togglePayNow), primary: true, 'data-at': 'togglePayLate'},
    ];

    return (
      <Dialog active={true} actions={actions} title={formatMessage({id: 'updateDebitCard.hasLatePayments.title'})}>
        <div styleName="dialogText" data-at="hasLatePaymentsText" >{formatMessage({id: 'updateDebitCard.hasLatePayments.text'})}</div>
      </Dialog>
    );

  }

  render() {
    const {purchase} = this.props;
    const { intl: { formatMessage } } = this.props;

    return (
      <div styleName="updateDebitCard" data-at="updateDebitCardContainer" >
        <div styleName="partition">
          <PurchaseInfo purchase={purchase}/>
        </div>

        <div styleName="partition" data-at="currentDebitCardTxt" >
          {formatMessage({ id: 'payNow.paymentMethod.current' }, { paymentMethod: getCurrentPaymentMethodTextByPurchase(purchase) })}
        </div>

        <div styleName="instructions partition">
          <FormattedMessage id="updateDebitCard.form.instructions" />
        </div>

        <DebitCardForm cvvKey={this.state.cvvKey} onChange={this.onChange} name="debitCardDetails" />

        <div styleName="partition bottom">
          {this.renderApplyButton()}
        </div>

        {this.state.authorizationDialogVisible && this.renderAuthorizationDialog()}
        {this.state.hasLatePaymentsDialog && this.renderHasLatePaymentsDialog()}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/purchases/update-debit-card/UpdateDebitCard.js